module.exports = __webpack_public_path__ + "static/catalog-fe6897e8817fc22cc2f788ac2292eb82.pdf";